import { render } from "./HomePosts.vue?vue&type=template&id=69d1c4ac&scoped=true"
import script from "./HomePosts.vue?vue&type=script&lang=js"
export * from "./HomePosts.vue?vue&type=script&lang=js"

import "./HomePosts.vue?vue&type=style&index=0&id=69d1c4ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d1c4ac"]])

export default __exports__